import { useCallback, useEffect, useRef } from "react";
export function useGotFocusTroughTabbing(ownRef) {
    const gotFocusThroughTabbingRef = useRef(false);
    useEffect(() => {
        const element = ownRef.current;
        if (!element) {
            return undefined;
        }
        const handleFocusIn = (event) => {
            const previousElement = event.relatedTarget;
            if (previousElement === null ||
                previousElement === element ||
                element.contains(previousElement)) {
                return;
            }
            gotFocusThroughTabbingRef.current = true;
        };
        element.addEventListener("focusin", handleFocusIn);
        return () => {
            element.removeEventListener("focusin", handleFocusIn);
        };
    }, [ownRef]);
    const set = useCallback((value) => {
        gotFocusThroughTabbingRef.current = value;
    }, []);
    return [gotFocusThroughTabbingRef.current, set];
}
